import React, { Component } from 'react';
import { Layout, PageHeader, Tag, Table, Divider, Button, Typography } from 'antd';
import CommonLayout from '@/components/Documents/common/layout';
import SiderMenu from '@/components/SiderMenu'
import { connect } from '@souche-f2e/muji';
import styles from './index.module.less';
import { IRootState } from '@@/store';
import { menuData, codeInfo } from "./notice-menu-data";
const ReactMarkdown = require('react-markdown/with-html');
import markdownAuth from "./markdown_auth";
import markdownQuckAccess from "./markdown_quick_access";
import { dispatch } from '@@/store';

const mapStateToProps = (rootState) => {
  return { 
    currentRoute: rootState.router,
    documents: rootState.documents
  };
};
const { Title, Text } = Typography;

@connect(mapStateToProps)

class ToolsLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemPath: '对接流程 / 快速开始',
    };
    this.setMenuItemKeyPath = (keyPath) => {
      this.setState(() => {
        return {itemPath: '对接流程 / ' + keyPath}
      })
    };
    this.setDocId = (docId) => {
      dispatch.documents.updatePath({
        docId,
      });
    }
  }

  getChildrenByDocId = () => {
    const docId = this.props.documents.docId;
    switch (docId) {
      case 0:
        return (<Layout.Content className={styles.layoutContent}>
          <div className={styles.breadcrumb}>{this.state.itemPath}</div>
          <PageHeader>
            <div className={styles.content}>
              <p className={styles.text}>本文主要描述对接所需的基本接口规则。</p>
              <Title level={2}>接入流程</Title>
              <Text>
                1. 申请成为大搜车开放平台合作商，获取 appKey 和 appSecret。<br />
                2. 申请需要用到服务的权限。<br />
                3. 参考认证鉴权方式对每个请求进行签名，使用签名请求大搜车开放平台服务。
              </Text>

              <Title level={2}>接口说明</Title>
              <Text>
                接口需要认证，具体方式参考 认证鉴权文档 。<br />
                接口接收与响应参数均为 JSON 格式。<br />
                接口接收与响应字符集均为 UTF-8。<br />
                接口只有一个请求地址，HTTP 请求方式(METHOD)为 POST，请求的具体 API 与参数放在 HTTP 请求体(Body) 中
              </Text>

              <Title level={2}>请求地址</Title>
              <Text>
                测试环境：POST <Text copyable>http://openapi.proxy.dasouche.com/v3</Text><br />
                预发环境：POST <Text copyable>http://openapi.prepub.souche.com/v3</Text><br />
                线上环境：POST <Text copyable>https://openapi.souche.com/v3</Text><br />
              </Text>

              <Title level={2}>请求参数</Title>
              <Text>
                api: [JSON String] 具体 API 名称。<br/>
                appKey: [JSON String] 咲夜开放平台生成的账户 appKey。<br/>
                timestamp: [JSON Number] 秒级别时间戳。<br/>
                data: [JSON Object String] 具体 API 要求的输入参数。<br/>
                sign: [JSON Strig] 签名，具体方式参考认证鉴权。<br/>
              </Text>

              <Title level={2}>响应数据</Title>
              <div className={styles.markdownContainer}>
                <ReactMarkdown source={markdownQuckAccess} escapeHtml={false}></ReactMarkdown>
              </div>
            </div>
          </PageHeader>
          <Divider className={styles.line}/>
        </Layout.Content>);
        break;
      case 1:
        return (<Layout.Content className={styles.layoutContent}>
          <div className={styles.breadcrumb}>{this.state.itemPath}</div>
          <PageHeader>
            <div className={styles.content}>
              <p className={styles.text}> 签名可以按需使用 HTTP 方式 或 JAVA SDK 方式</p>
              {/*<Table*/}
              {/*bordered={true}*/}
              {/*pagination={false}*/}
              {/*rowKey={item => item.meaning || 'key'}*/}
              {/*columns={coedColumns}*/}
              {/*dataSource={codeInfo}*/}
              {/*/>*/}
              <div className={styles.markdownContainer}>
                <ReactMarkdown source={markdownAuth} escapeHtml={false}></ReactMarkdown>
              </div>
            </div>
          </PageHeader>
          <Divider className={styles.line}/>
          {/*<p className={styles.contentFooter}>找到解决办法了吗？前往*/}
            {/*&nbsp;<a href="/#/FAQ" target="_blank" >FAQ</a> &nbsp;*/}
            {/*再找找*/}
          {/*</p>*/}
        </Layout.Content>);
        break;
      case 2: // 错误码
        const  coedColumns = [
          {
            title: 'HTTP码',
            dataIndex: 'httpCode',
            key: 'httpCode',
          },
          {
            title: 'API码',
            width: '20%',
            dataIndex: 'apiCode',
            key: 'apiCode',
          },
          {
            title: '描述',
            width: '22%',
            dataIndex: 'meaning',
            key: 'meaning',
          },
          {
            title: '常见解决方案',
            width: '42%',
            key: 'solution',
            render: (text, record) => {
              const getSolutions = solutionList => {
                const children = [];
                solutionList.forEach(solution => children.push(<p> {solution} </p>));
                return children;
              };

              if (record.solution.length > 0) {
                return <span>{getSolutions(record.solution)}</span>;
              }
              return <span>暂无方案说明</span>;
            },
          },
        ];
        return (<Layout.Content className={styles.layoutContent}>
          <div className={styles.breadcrumb}>{this.state.itemPath}</div>
          <PageHeader
            title="错误码排查介绍"
            tags={<Tag color="red">持续更新</Tag>}
            extra={
              <div>
                <span key="3">更新时间：2019-07-31 </span>
              </div>
            }
          >
            <div className={styles.content}>
              <p className={styles.text}>本文主要引导大家通过开放平台官方提供的API错误码，对调用的结果可以进行简单的分析。</p>
              <Table
                bordered={true}
                pagination={false}
                rowKey={item => item.meaning || 'key'}
                columns={coedColumns}
                dataSource={codeInfo}
              />
            </div>
          </PageHeader>
          <Divider className={styles.line}/>
          <p className={styles.contentFooter}>找到解决办法了吗？前往
            &nbsp;<a href="/#/support/FAQ" target="_blank" >FAQ</a> &nbsp;
            再找找
          </p>
        </Layout.Content>);
        break;
      default:
        break;
    }
  };

  render() {
    const {
      currentRoute,
    } = this.props;
    // 文档目录
    const docMenu = true;

    return (
      <Layout
        tabkey={'docking_process'}
        className={styles.container}>
        <SiderMenu
          menuData={menuData}
          currentRoute={currentRoute}
          className={styles.siderMenu}
          isDocMenu={docMenu}
          setMenuItemKeyPath={this.setMenuItemKeyPath}
          setDocId={this.setDocId}
          titleName='对接流程'
          style={{
            padding: '16px 0',
            width: '100%',
            borderRight: 'none'
          }}
        />
        {this.getChildrenByDocId()}
      </Layout>
    )
  }
}

export default function() {
  return (
    <CommonLayout tabkey={'docking_process'}>
      <ToolsLayout />
    </CommonLayout>
  )
}
